<template>
  <div class="list-analytics analysis-chart" v-show="mainChartVisible">
    <div class="t-chart">
      <div class="title">역률</div>
      <w-plot-line-chart ref="frtPowerFactorChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" @clickChart="onClickChart" />
    </div>
  </div>
</template>

<script>
import { performanceChart } from '@/mixins/performance/charts';
import WPlotLineChart from '@/views/performance/node/analysis/components/PlotLineChart';

export default {
  name: 'WFrtPowerFactorAnalysisChart',
  components: { WPlotLineChart },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
  },
  data() {
    return {
      mainRscInfoList: [{ rsctypeId: 'FRT', rscId: 'POWER_FACTOR_A', rscKey: '_' }, { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_B', rscKey: '_' }, { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_C', rscKey: '_' }],
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/sensor/components/chart/FrtPowerFactorAnalysisChart.vue